import React from "react";
// importing Components
// import NavBar from "../components/NavBar";
import IntroSection from "../components/IntroSection";
import Footer from "../components/Footer";

function AboutMe() {
  return (
    <div>
      {/* <NavBar /> */}
      <IntroSection />
      <Footer />
    </div>
  );
}

export default AboutMe;
